import React from 'react';
import {injectIntl} from "react-intl";

class NoSafeManagement extends React.Component {

  render() {
    const {intl: {formatMessage}, title} = this.props;

    return (
      <section className="box">
        <header className="box-heading">
          <h2 className="box-heading__title">
            {formatMessage({id: title})}
          </h2>
        </header>

        <div className="box__body">
          {formatMessage({id: 'safe.configuration.unavailable'})}
        </div>
      </section>
    )
  }
}

export default injectIntl(NoSafeManagement);



// WEBPACK FOOTER //
// ./src/components/safes/management/NoSafeManagement.js